<template>
  <v-container fluid>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle ml-10">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
      <v-col  cols="12" md="3" >
        <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          :disabled="!checkdate"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          :disabled="!checkdate"
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="12" md="1" sm="6" xs="6" class="d-flex justify-center">
        <v-checkbox v-model="checkdate" dense :label="$t('common_usedate')"/>
      </v-col>
      <v-col cols="12" md="2" sm="6" xs="6" class="d-flex justify-center">
        <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
        <v-btn class="ml-2" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px"> 
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('charteu_col1')}}</label>
          <label class="chartsum_value">{{sum1}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteu_col2')}}</label>
        <label class="chartsum_value">{{sum2}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteu_col3')}}</label>
        <label class="chartsum_value">{{sum3}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('charteu_col4')}}</label>
        <label class="chartsum_value">{{sum4}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t("charteu_col5")}}</label>
        <label class="chartsum_value">{{sum5}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t("charteu_col6")}}</label>
        <label class="chartsum_value">{{sum6}}</label>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-col>
        <v-simple-table 
          height="70vh"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th class="text-left header_text_style">{{$t("charteu_col7")}}</th>
                <th class="text-left header_text_style">{{$t("charteu_col8")}}</th>
                <th class="text-center header_text_style">{{$t("charteu_col1")}}</th>
                <th class="text-center header_text_style">{{$t("charteu_col2")}}</th>
                <th class="text-center header_text_style">{{$t("charteu_col3")}}</th>
                <th class="text-center header_text_style">{{$t("charteu_col4")}}</th>
                <th class="text-center header_text_style">{{$t("charteu_col5")}}</th>
                <th class="text-center header_text_style">{{$t("charteu_col6")}}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color:#f0f0f0">
                <td class="text-center"></td>
                <td class="text-right">{{$t("charteu_col9")}}</td>
                <td class="text-center">{{ priceToString(sum1) }}</td>
                <td class="text-center">{{ priceToString(sum2) }}</td>
                <td class="text-center">{{ priceToString(sum3) }}</td>
                <td class="text-center">{{ priceToString(sum4) }}</td>
                <td class="text-center">{{ priceToString(sum5) }}</td>
                <td class="text-center">{{ priceToString(sum6) }}</td>
              </tr>
              <tr v-for="item in list" :key="item.ROWNUM">
                <td class="text-left">{{ item.COMNAME }}</td>
                <td class="text-left">{{ item.EVENT_NAME }}</td>
                <td class="text-center">{{ priceToString(item.STEP1) }}</td>
                <td class="text-center">{{ priceToString(item.STEP2) }}</td>
                <td class="text-center">{{ priceToString(item.STEP3) }}</td>
                <td class="text-center">{{ priceToString(item.STEP4) }}</td>
                <td class="text-center">{{ priceToString(item.STEP5) }}</td>
                <td class="text-center">{{ priceToString(item.STEP6) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>

import moment from 'moment'
import XLSX from 'xlsx'
export default {

  beforeDestroy(){
  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.grade = this.$session.get("GRADE");
    
    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({

      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',
      checkdate : true,
      list:[],
      sum1:0,
      sum2:0,
      sum3:0,
      sum4:0,
      sum5:0,
      sum6:0,

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

  }),

  methods: {
    
    initpage(){
      this.search_run();
    },

    startDownload(){

      this.$confirm(this.$t('common_downexcel2')).then(() => {

        var templist = [];
        this.list.forEach(item=>{
          templist.push({
            "COMNAME":item.COMNAME
          , "EVENT_NAME":item.EVENT_NAME
          , "STEP1":parseInt(item.STEP1)
          , "STEP2":parseInt(item.STEP2)
          , "STEP3":parseInt(item.STEP3)
          , "STEP4":parseInt(item.STEP4)
          , "STEP5":parseInt(item.STEP5)
          , "STEP6":parseInt(item.STEP6)
          });
        });

        //하단 합계 넣기
        templist.push({
            "COMNAME":""
          , "EVENT_NAME":""
          , "STEP1":parseInt(this.sum1)
          , "STEP2":parseInt(this.sum2)
          , "STEP3":parseInt(this.sum3)
          , "STEP4":parseInt(this.sum4)
          , "STEP5":parseInt(this.sum5)
          , "STEP6":parseInt(this.sum6)
        });
        
        var item_sheet = XLSX.utils.json_to_sheet(templist);

        //상단 컬럼명 수정
        item_sheet.A1 = {v:this.$t('charteu_col7')};
        item_sheet.B1 = {v:this.$t('charteu_col8')};
        item_sheet.C1 = {v:this.$t('charteu_col1')};
        item_sheet.D1 = {v:this.$t('charteu_col2')};
        item_sheet.E1 = {v:this.$t('charteu_col3')};
        item_sheet.F1 = {v:this.$t('charteu_col4')};
        item_sheet.G1 = {v:this.$t('charteu_col5')};
        item_sheet.H1 = {v:this.$t('charteu_col6')};

        //컬럼별 너비
        var wscols = [{wch:20},{wch:30},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10}];
        item_sheet['!cols'] = wscols;

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('charteu_label1'));
        XLSX.writeFile(wb, this.$t('charteu_label1')+'_'+Date.now().toString()+'.xlsx');

      });    
      
    },

    search_run(){

      if(this.grade < 99){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_com'));
          return;
        }
      }

      if(this.checkdate){
        if(this.search_start_date.length < 4){
          this.$alert(this.$t('common_search_start_info1'));
          return;
        }
        if(this.search_end_date.length < 4){
          this.$alert(this.$t('common_search_end_info1'));
          return;
        }
        if(this.search_start_date > this.search_end_date){
          this.$alert(this.$t('common_search_date_error1'));
          return;
        }
      }

      this.$http.post(this.$host+'/api/ChartEventUser',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX == undefined ? '' : this.SEARCH_COM_IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{

        
        this.loading = false;
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.sum1 = 0;
            this.sum2 = 0;
            this.sum3 = 0;
            this.sum4 = 0;
            this.sum5 = 0;
            this.sum6 = 0;
            this.list.splice(0, this.list.length);   //데이터 초기화
            this.list = result.data.resultData;
            this.list.forEach(item =>{
              this.sum1 += parseInt(item.STEP1);
              this.sum2 += parseInt(item.STEP2);
              this.sum3 += parseInt(item.STEP3);
              this.sum4 += parseInt(item.STEP4);
              this.sum5 += parseInt(item.STEP5);
              this.sum6 += parseInt(item.STEP6);
            })


        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        
        this.loading = false;
      });

    },

    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },


    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

        this.search_start_date = moment(val1.EVENT_START, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.search_end_date  = moment(val1.EVENT_END, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.$session.set("EVENT_START", this.search_start_date);
        this.$session.set("EVENT_END", this.search_end_date);

      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);

      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>